import { FieldActionContext } from "../contexts/FieldActionContext";
import { IInputOnlyFieldProps, InputOnlyField, IValidationError } from "@ngt/forms";
import { IFieldAfterRegistrationEvent, InputComponentType, OmitInputProps } from "@ngt/forms-core";
import { ComponentProps, useCallback, useContext } from "react";
import { StepContext } from "../contexts/StepContext";

export interface IApplicationField<
    TComponent extends InputComponentType = any,
    TValue = any,
    TForm extends object = any
    > extends IInputOnlyFieldProps<TComponent, TValue, TForm> {
}

const ApplicationField = <
    TComponent extends InputComponentType = any,
    TValue = any,
    TForm extends object = any
> (props: IApplicationField<TComponent, TValue, TForm> & Partial<OmitInputProps<ComponentProps<TComponent>>>) => {

    const setFields = useContext(FieldActionContext);
    const step = useContext(StepContext);

    const onAfterRegister: IFieldAfterRegistrationEvent<TValue, TForm, IValidationError> = useCallback((context) => {
        props?.FieldProps?.onAfterRegister?.(context);

        setFields(current => {
            return {
                ...current,
                [step]: Array.from(new Set([...(current[step] ?? []), context?.getPropertyPath()! ]))
            }
        });
    }, [props?.FieldProps?.onAfterRegister, setFields, step]);

    return <InputOnlyField
        {...props} 
        FieldProps={{
            ...props.FieldProps,
            onAfterRegister: onAfterRegister
        }}
    />;
}

export default ApplicationField;